(() => {
  function init() {
    const modal = document.getElementById('AvrenoaOffer');
    if (!modal || modal.dataset.ready) return;
    modal.dataset.ready = 'true';
    if (window.avrenoaOfferEvents) window.avrenoaOfferEvents.abort();
    const controller = new AbortController();
    window.avrenoaOfferEvents = controller;
    const form = modal.querySelector('form');
    const key = 'avrenoa-offer-pending';
    let opener;
    const open = (trigger) => {
      opener = trigger || document.querySelector('[data-offer-open], a[href="#AvrenoaOffer"]');
      if (!modal.open) modal.showModal();
    };
    document.addEventListener('click', event => { const button = event.target.closest('[data-offer-open], a[href="#AvrenoaOffer"]'); if (!button) return; event.preventDefault(); open(button); }, { signal: controller.signal });
    modal.querySelector('[data-offer-close]').addEventListener('click', () => modal.close());
    modal.addEventListener('click', event => {
      if (event.target !== modal) return;
      const rect = modal.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) modal.close();
    });
    modal.addEventListener('close', () => { if (opener) opener.focus(); });
    form.addEventListener('submit', () => { try { sessionStorage.setItem(key, String(Date.now())); } catch (_) {} });
    let pending = false;
    try { const time = Number(sessionStorage.getItem(key)); pending = time > 0 && Date.now() - time < 1800000; } catch (_) {}
    if ((pending || location.hash === '#AvrenoaOfferForm') && modal.querySelector('[data-offer-success], [data-offer-errors]')) {
      open();
      try { sessionStorage.removeItem(key); } catch (_) {}
    }
    const copy = modal.querySelector('[data-offer-copy]');
    if (copy) copy.addEventListener('click', async () => {
      const code = modal.querySelector('[data-offer-code]');
      const status = modal.querySelector('[data-copy-status]');
      try { await navigator.clipboard.writeText(code.value); status.textContent = copy.dataset.copied; }
      catch (_) { code.focus(); code.select(); status.textContent = copy.dataset.error; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
